export const notAppliedLabel = 'Not Applied';
